import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import localIp from './localIp';
import { getFlag } from './util/flags';

const localConfig = {
  apiBase: '/localApi',
  streamServerBase: 'http://localhost:3001',
  firebaseConfig: {
    apiKey: 'AIzaSyAfQvRE1v-ddLwVFklZeKk2YqXdV8QP-I8',
    authDomain: 'voicerecap-dev.firebaseapp.com',
    projectId: 'voicerecap-dev',
    storageBucket: 'voicerecap-dev.appspot.com',
    messagingSenderId: '903791485961',
    appId: '1:903791485961:web:da82232205b49a4c7b84d8',
  },
  magicPublishableKey: 'pk_live_5ADEABFBC3086CA7',
  googleAnalyticsMeasurementId: null,
};

const betaConfig = {
  // The create-react-app proxy handles API requests in development: https://create-react-app.dev/docs/proxying-api-requests-in-development/
  apiBase:
    process.env.NODE_ENV === 'development'
      ? '/betaApi'
      : 'https://us-central1-voicerecap-dev.cloudfunctions.net',
  streamServerBase:
    process.env.NODE_ENV === 'development'
      ? '/betaApi/stream'
      : 'https://voicerecap-dev.uc.r.appspot.com',
  firebaseConfig: {
    apiKey: 'AIzaSyAfQvRE1v-ddLwVFklZeKk2YqXdV8QP-I8',
    authDomain: 'voicerecap-dev.firebaseapp.com',
    projectId: 'voicerecap-dev',
    storageBucket: 'voicerecap-dev.appspot.com',
    messagingSenderId: '903791485961',
    appId: '1:903791485961:web:da82232205b49a4c7b84d8',
  },
  magicPublishableKey: 'pk_live_5ADEABFBC3086CA7',
  googleAnalyticsMeasurementId: 'G-C9NND8B8N4',
};

const prodConfig = {
  // The create-react-app proxy handles API requests in development: https://create-react-app.dev/docs/proxying-api-requests-in-development/
  apiBase:
    process.env.NODE_ENV === 'development'
      ? '/prodApi'
      : 'https://us-central1-griffinscribe-656d9.cloudfunctions.net',
  streamServerBase:
    process.env.NODE_ENV === 'development'
      ? '/prodApi/stream'
      : 'https://griffinscribe-656d9.wl.r.appspot.com',
  firebaseConfig: {
    apiKey: 'AIzaSyCE_0OFKPLZjHM-QBj0MxnrLfrcpMa6srA',
    authDomain: 'griffinscribe-656d9.firebaseapp.com',
    projectId: 'griffinscribe-656d9',
    storageBucket: 'griffinscribe-656d9.appspot.com',
    messagingSenderId: '1080603572087',
    appId: '1:1080603572087:web:afb1440c126089e21f1372',
  },
  magicPublishableKey: 'pk_live_CA78F24781D3BBF6',
  googleAnalyticsMeasurementId: 'G-YJHVEE502D',
};

const config = (() => {
  if (getFlag('localApi')) return localConfig;
  if (getFlag('betaApi')) return betaConfig;
  return prodConfig;
})();

export default config;

export const firebaseApp = initializeApp(config.firebaseConfig);

// Lazy-load firebase/storage to avoid bringing unnecessary deps into the main index.js
// firebase/auth gets imported non-lazily in other places from the main chunk, so lazy-loading here isn’t necessary
import('./firebaseAnalytics');
if (getFlag('localApi')) {
  (async () => {
    const { connectStorageEmulator, getStorage } = await import('firebase/storage');
    connectAuthEmulator(getAuth(firebaseApp), `http://${localIp}:9099`);
    connectStorageEmulator(getStorage(firebaseApp), localIp, 9199);
  })();
}
